import React, {useState} from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const BranchTransactionOutwardTable = ({ printMode = false }) => {
  const { list, loading } = useSelector(
    (state) => state.branchTransactionOutward
  );

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { title: "Tran Code", dataIndex: "tran_code" },
    {
      title: "Tran Date",
      dataIndex: "tran_date",
      render: (val) => dayjs(val).format("DD MMM YYYY"),
    },
    { title: "To Branch", dataIndex: "name" },
    { title: "From Account", dataIndex: "from_acc_name" },
    { title: "To Branch Account", dataIndex: "to_acc_name" },
    { title: "Description", dataIndex: "narration" },
    { title: "Created By", dataIndex: "full_name" },
    {
      title: "Status",
      dataIndex: "status",
      render: (val) =>
        val === "a" ? "Active" : val === "p" ? "Pending" : val,
    },
    {
      title: "Amount",
      dataIndex: "tran_amount",
      align: "right",
      render: (val) => fmt(val),
    },
  ];

  const totalAmount = list.reduce(
    (sum, r) => sum + Number(r.tran_amount || 0),
    0
  );

  if (printMode) {
  return (
    <table className="bto-print-table">
     <colgroup>
  <col style={{ width: "4%" }} />
  <col style={{ width: "9%" }} />
  <col style={{ width: "9%" }} />
  <col style={{ width: "11%" }} />
  <col style={{ width: "13%" }} />
  <col style={{ width: "13%" }} />
  <col style={{ width: "15%" }} />
  <col style={{ width: "10%" }} />
  <col style={{ width: "6%" }} />
  <col style={{ width: "10%" }} />
</colgroup>

      <tbody>
        <tr className="bto-print-heading">
          <td>No.</td>
          <td>Tran Code</td>
          <td>Tran Date</td>
          <td>To Branch</td>
          <td>From Account</td>
          <td>To Branch Account</td>
          <td>Description</td>
          <td>Created By</td>
          <td>Status</td>
          <td style={{ textAlign: "right" }}>Amount</td>
        </tr>

        {list.map((row, index) => (
          <tr key={row.tran_code || index}>
            <td>{index + 1}</td>

            <td>{row.tran_code}</td>

            <td>
              {row.tran_date
                ? dayjs(row.tran_date).format("DD MMM YYYY")
                : ""}
            </td>

            <td>{row.name}</td>
            <td>{row.from_acc_name}</td>
            <td>{row.to_acc_name}</td>
            <td>{row.narration}</td>
            <td>{row.full_name}</td>

            <td>
              {row.status === "a"
                ? "Active"
                : row.status === "p"
                ? "Pending"
                : row.status}
            </td>

            <td style={{ textAlign: "right" }}>
              {fmt(row.tran_amount)}
            </td>
          </tr>
        ))}

        <tr className="bto-print-total">
          <td colSpan={9} style={{ textAlign: "right", whiteSpace: "nowrap" }}>
            Grand Total :
          </td>

          <td style={{ textAlign: "right", whiteSpace:"nowrap" }}>
            {fmt(totalAmount)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

  return (
    <Table
      rowKey={(record, idx) => record.tran_code || idx}
      columns={columns}
      dataSource={list}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      size={printMode ? "small" : "middle"}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={9} align="right">
            <strong>Grand Total :</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={9} align="right">
            <strong>{fmt(totalAmount)}</strong>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    />
  );
};

export default BranchTransactionOutwardTable;
